import React, { Component } from 'react'

export default class Unauthorized extends Component {
  render() {
    return <div>You are not authorized to view this content</div>
  }
}
